var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doctor-row"},_vm._l((_vm.rowData),function(data,index){return _c('div',{key:index},[(data.id)?_c('span',{staticClass:"row-id"},[_vm._v(_vm._s(`${data.id}`))]):_vm._e(),_c('span',{staticClass:"row-name"},[_vm._v(_vm._s(` ${data.nama}`))]),(_vm.rowData.length > 1)?_c('div',{staticClass:"row-divider"}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }